import { useContext } from 'react';
import { Card, Label, CardSubtitle } from 'reactstrap';
import { FundRequestContext } from '~/context/fundrequests';
import { BlueHorizontalLine } from '~/shared/components/icons';

const PayeeDetails = () => {
    const [{ fundRequest }, fundRequestDispatch] =
        useContext(FundRequestContext);

    // Get vendor details - handle case where vendor might be null
    const { name, email, phone, payment_type } = fundRequest.vendor || {};

    const paymentType = fundRequest?.payment_type || payment_type;

    // Get the selected vendor address directly from fundRequest
    const address = fundRequest.vendor_address;

    // Don't render if no vendor is assigned
    if (!fundRequest.vendor) {
        return null;
    }

    return (
        <Card style={{ background: 'transparent' }}>
            {/* <CardBody> */}
            <Label style={{ fontSize: '1rem' }}> Payee</Label>
            <BlueHorizontalLine />
            <CardSubtitle className='mb-2 fw-bold'>
                {name} {address?.address_label && `(${address.address_label})`}
            </CardSubtitle>
            <CardSubtitle className='mb-2'>{address?.address_1}</CardSubtitle>
            {address?.address_2 && (
                <CardSubtitle className='mb-2'>
                    {address.address_2}
                </CardSubtitle>
            )}
            <CardSubtitle className='mb-2'>
                {address?.city}, {address?.state?.abbreviation}
            </CardSubtitle>
            <CardSubtitle className='mb-2'>{address?.zip_code}</CardSubtitle>
            <CardSubtitle className='mb-2'>{phone}</CardSubtitle>
            <CardSubtitle className='mb-2 text-primary fw-bold'>
                {email}
            </CardSubtitle>
            <CardSubtitle className='mb-2 '>
                Preferred Payment Method:
                <p
                    style={{
                        display: 'inline',
                        fontWeight: 600,
                        marginLeft: 5,
                    }}
                >
                    {paymentType}
                </p>
            </CardSubtitle>
        </Card>
    );
};

export default PayeeDetails;
